import React, { useContext } from 'react';
import styles from './index.module.scss';
import { DataLayerEventContext } from '../../../contexts/dataLayerEventContext';
import { getImageFromS3 } from '../../../imageService';

const packs = [
  {
    image: '/images/sms-prl-rvmp/pack-night-blue.png',
    name: 'Night Blue',
    tar: '9'
  },
  {
    image: '/images/sms-prl-rvmp/pack-aqua-blue.png',
    name: 'Aqua Blue',
    tar: '6'
  },
  {
    image: '/images/sms-prl-rvmp/pack-silver-blue.png',
    name: 'Silver Blue',
    tar: '4'
  },
  {
    image: '/images/sms-prl-rvmp/pack-platinum.png',
    name: 'Platinum',
    tar: '1'
  }
];

const shops = [
  {
    logo: '/images/shops/fora-logo.png',
    alt: 'fora',
    style: { width: 64, height: 22 }
  },
  {
    logo: '/images/shops/silpo-logo.png',
    alt: 'silpo',
    style: { width: 60, height: 24 }
  },
  {
    logo: '/images/shops/wog-logo.png',
    alt: 'wog',
    style: { width: 75, height: 23 }
  },
  {
    logo: '/images/shops/okko-logo.png',
    alt: 'okko',
    style: { width: 42, height: 55 }
  },
  {
    logo: '/images/shops/novus-logo.png',
    alt: 'novus',
    style: { width: 65, height: 14 }
  },
  {
    logo: '/images/shops/tabakerka-logo.png',
    alt: 'tabakerka',
    style: { width: 72, height: 17 }
  }
];

const HomeScreen = () => {
  const { sendEvent } = useContext(DataLayerEventContext);

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.stage}>
          <img
            className={styles.headBg}
            src={getImageFromS3('images/sms-prl-rvmp/head-bg.png')}
            alt="head-bg"
          />
          <img
            className={styles.formatBg}
            src={getImageFromS3('images/sms-prl-rvmp/format-bg.png')}
            alt="format-bg"
          />
          <img
            className={styles.logo}
            src={getImageFromS3('images/sms-prl-rvmp/logo.png')}
            alt="logo"
          />
          <p className={styles.headTitle}>НЕЗМІННА ЯКІСТЬ</p>
          <p className={styles.headSubtitle}>
            Лінійка “Кінг Сайз”
            <br />
            Стандарт
          </p>
          <div className={styles.packsRow}>
            {packs.map((pack) => (
              <div className={styles.packItem} key={pack.name}>
                <img src={pack.image} alt={pack.name} />
                <p className={styles.packName}>{pack.name}</p>
                <div className={styles.packTar}>
                  <b>{pack.tar}</b>
                  <span> мг</span>
                </div>
              </div>
            ))}
          </div>
          <img
            className={styles.filterIcon}
            src={getImageFromS3('images/sms-prl-rvmp/filter.png')}
            alt="filter"
          />
          <p className={styles.filterText}>
            <b>Recessed 2.0</b>
            <br />
            фільтр з повітряною камерою
          </p>
          <img
            className={styles.tobaccoIcon}
            src={getImageFromS3('images/sms-prl-rvmp/tobacco.png')}
            alt="tobacco"
          />
          <p className={styles.tobaccoText}>
            <b>Тютюнова суміш</b>
            <br />
            від Parliament
          </p>
          <img
            className={styles.lenses}
            src="/images/sms-prl-rvmp/lenses.png"
            alt="pack"
          />
          <div className={styles.buyContainer}>
            <p className={styles.buyTitle}>Де купити?</p>
            <p className={styles.buyDescription}>
              Актуальний асортимент можна знайти у роздрібних точках продажу,
              зокрема:
            </p>
            <div className={styles.shopsContainer}>
              {shops.map((shop) => (
                <div className={styles.shopItem} key={shop.alt}>
                  <img src={shop.logo} alt={shop.alt} style={shop.style} />
                </div>
              ))}
            </div>
          </div>
          <div className={`${styles.buyContainer} ${styles.orContainer}`}>
            <p className={styles.buyTitle}>Або</p>
            <p className={styles.buyDescription}>
              Актуальний асортимент можна знайти на офіційних онлайн сервісах,
              зокрема:
            </p>
            <div className={styles.buttonContainer}>
              <a
                href="https://rozetka.com.ua/ua/sigareti/c4638591/price=1800-1800;producer=parliament/?utm_source=PMUsmsRevamp"
                target="_blank"
                rel="noopener noreferrer"
                className={styles.buttonItem}
                onClick={() => sendEvent('rozetka')}
              >
                <img src="/images/sms-prl-rvmp/glass.png" alt="glass" />
                <p>Rozetka</p>
              </a>
              <a
                href="https://cig-poshta.in.ua/shop/parliament/?utm_source=CDAsmsRevamp"
                target="_blank"
                rel="noopener noreferrer"
                className={styles.buttonItem}
                onClick={() => sendEvent('cig-poshta')}
              >
                <img src="/images/sms-prl-rvmp/glass.png" alt="glass" />
                <p>Cig-poshta</p>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.footer}>
        Куріння викликає
        <br />
        серйозні захворювання
        <br />
        та залежність
        <br />
        Дана інформація про
        <br />
        продукт надається
        <br />
        відповідно
        <br />
        до статті 15 Закону
        <br />
        України «Про захист
        <br />
        прав споживачів»
      </div>
      <div className={styles.unsubscribe}>
        Ти отримав(-ла) повідомлення, оскільки залишав(-ла) запит на отримання
        інформації про продукцію компаній Philip Morris в Україні. <br />
        <a href="/unsubscribe?returnLink=25-sms-prl-line">
          Відписатися від SMS тут.
        </a>
      </div>
    </div>
  );
};

export default HomeScreen;
